module.exports = __webpack_public_path__ + "img/line-white-icon.cb7a315a.svg";